<template>
  <section class="latest-news">
    <div class="container">

      <div class="news-title-container" v-if="position == 'home'">
        <Title :class="'latest-news-title'" :title=title size="large" color="darkblue" :translate=true direction="none" type="news" />
        <AppButton cta="see_all_news" class="button button-inline" type="router" route="news" />
      </div>

      <h2 v-if="position == 'news_view'" class="latest-news-title roboto-condensed">{{$t(title)}}</h2>

      <div class="news-items-wrapper" :class="'news-total-'+recentPosts.length">

        <NewsItem v-for="post, key in recentPosts" position="home" :key=key :index=key :post=post :total=total />

      </div>

    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import AppButton from '@/components/ui/AppButton';
import Title from '@/components/ui/Title';
import NewsItem from '@/components/ui/news/NewsItem';

export default {
  name: 'LatestNews',
  components: {
     AppButton,
     Title,
     NewsItem
  },
  props: ['title', 'position','slug'],
  created() {
    this.getLatestPosts();
    this.getPosts();
  },
  computed: {
    ...mapGetters({
      latestPosts: 'latestPosts',
      posts: 'posts',
    }),
    recentPosts() {
      if(this.position === 'news_view') {
        let posts = this.posts;
        if(posts.length > 0) {
          posts = posts.slice(0,4).filter((p) => p.slug !== this.slug )
        }
        return posts;

      } else {
        return this.latestPosts;
      }
    },
    total() {
      return this.latestPosts.length;
    }
  },
  methods: {
    ...mapActions({
      getLatestPosts: 'getLatestPosts',
      getPosts: 'getPosts',
    }),
  }

};
</script>

<style lang="scss">

  .latest-news-title {
    text-transform: uppercase;
    font-size: 17px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    padding: 6vw 0;

    @include bp($bp--m) {
      padding: 4vw 0;
      font-size: 28px;
      text-align: left;
    }
    
    @include bp($max-width) {
      padding: 30px 0 40px 0;
    }
  }
  .latest-news .container {
    @include bp($max-width) {
      padding: 0 20px;
    }
  }

  .news-title-container {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    @include bp($bp--m) {
      flex-direction: row;
      align-items: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/news/LatestNews.vue